(function (factory) {
   typeof define === 'function' && define.amd ? define('script', factory) :
   factory();
}((function () { 'use strict';

   function cleanForm(form) {
      form.reset();
   }

   // see other events https://contactform7.com/dom-events/
   const wpcf7Elm = document.querySelector( '[form-feedback] form' );
   if(wpcf7Elm) {
       const modalThankyou = document.querySelector('[data-modal="thankyou"]');
       wpcf7Elm.addEventListener( 'wpcf7mailsent', function( response ) {
           openPopup(modalThankyou);
           cleanForm(wpcf7Elm);
       }, false );
       wpcf7Elm.addEventListener( 'wpcf7mailfailed', function( response ) {
           openPopup(modalThankyou);
           cleanForm(wpcf7Elm);
       }, false );
   }



   const modalOpenBtn = document.querySelectorAll('[data-modal-open]');
   let modal;

   modalOpenBtn.forEach(btnItem => btnItem.addEventListener(`click`, openPopupModal));

   function openPopupModal(evt) {
       evt.preventDefault();
       let dataPopup = this.dataset.modalOpen;
       const prop = {
           redirectLink: this.dataset.link
       };
       modal = document.querySelector(`[data-modal="${dataPopup}"]`);
       openPopup(modal, prop);
   }

   function closePopup(modal) {
       let modalCloseBtn = modal.querySelectorAll("[data-modal-close]");
       modalCloseBtn.forEach(btn => btn.addEventListener("click", function (evt) {
           modal.classList.remove("active");
           document.body.style.overflow = 'auto';
       }));

   }

   function openPopup(modal, prop) {
       let link = modal.querySelector('a[modal-redirect]');
       if(link) link.href= prop.redirectLink;
       modal.classList.add("active");
       document.body.style.overflow = 'hidden';
       closePopup(modal);
   }

   window.addEventListener("keydown", function (evt) {
       if (evt.keyCode === 27) {
           if (modal.classList.contains("active")) {
               evt.preventDefault();
               modal.classList.remove("active");
           }
       }
   });

   jQuery(document).ready(function () {
       if(jQuery("[loadmore-items] li").length != 0) {
           const size_li = jQuery("[loadmore-items] li").size();
           let x = 1 - size_li;
           jQuery('[loadmore-items] li:gt(' + x + ')').hide();
           jQuery('[loadmore-btn]').click(function () {
               jQuery(this).hide();
               jQuery('[loadmore-items] li').show();
           });
       }
   });

   class Quantity {
       constructor(obj, value = 1) {
           this.value = value;
           this.obj = obj;
           this.toAjax = null;
           this.specialValue = [];
           this.controller = {};
           this.toggles = this.obj.querySelectorAll('[quantity-toggle]');
           this.mutables = this.obj.querySelectorAll('[quantity-mutable]');
           this.inputs = this.obj.querySelectorAll('[quantity-input]');
           this.links = this.obj.querySelectorAll('[quantity-link]');
           this.calculate = this.obj.querySelector('[quantity-calculate]');
       }
       init() {
           if (this.toggles) this.toggles.forEach(toggle => {
               toggle.addEventListener('click', (e) => {
                   e.preventDefault();
                   this.onToggle(toggle);
               });
               this.specialValue.push(toggle.getAttribute('quantity-value'));
           });
           
           if(this.inputs) this.inputs.forEach(input => {
               input.addEventListener('change', (e) => {
                   e.preventDefault();
                   this.onInput(input);
               });
               input.addEventListener('input', (e) => {
                   e.preventDefault();
                   this.onInput(input);
               });
           });

           this.controller = this.fetchController();
       }
       onToggle(self) {
           if(!self.classList.contains('active')) {
               this.controller.abort();
               this.controller = this.fetchController();
               this.resetToggles();
               self.classList.add('active');
               this.value = self.getAttribute('quantity-value');
               if(this.mutables) this.toggleMutables();
               if(this.links) this.setQuantityToLinks();
               if(this.inputs) this.resetInputs();
               if(this.calculate) this.resetCalculate();
           }
       }
       onInput(self) {
           // this.value = (self.value > 0) ? self.value : 1;
           console.log(self.value);
           if(self.value.length > 3) {
               self.value = self.value.slice(0, 3);
           }
           this.value = self.value;
           if(this.toggles) this.resetToggles();
           if(this.mutables) this.toggleMutables();
           if(this.links) this.setQuantityToLinks();

           if(this.toAjax !== null) clearTimeout(this.toAjax);
           this.toAjax = setTimeout(() => {
               this.updateCalculate();
               this.toAjax = null;
           }, 500);
           
       }
       toggleMutables() {
           this.resetMutable();
           if(this.specialValue.includes(this.value)) {
               this.mutables.forEach(item => {
                   if(item.hasAttribute('quantity-value') && item.getAttribute('quantity-value') == this.value) {
                       item.classList.add('active');
                   }
               });
           } else {
               this.mutables[0].classList.add('active');
           }
       }
       setQuantityToLinks() {
           this.links.forEach(link => {
               const reg = /quantity=\d+/;
               link.href = link.href.replace(reg, `quantity=${this.value}`);
           });
       }
       resetMutable() {
           for(let item of this.mutables) {
               item.classList.remove('active');
           }
       }
       resetToggles() {
           for(let item of this.toggles) {
               item.classList.remove('active');
           }
       }
       resetInputs(){
           this.inputs.forEach(input => input.value = '');
       }
       resetCalculate() {
           this.calculate.innerHTML = '';
       }
       fetchController() {
           let controller = new AbortController();
           controller.signal.addEventListener('abort', () => console.log("Cancel request!"));
           return controller;
       }
       async updateCalculate() {
           if(this.value > 0) {
               const formData = new FormData();
               formData.append('action', 'update_calculate');
               formData.append('quantity', this.value);
               formData.append('product_id', this.calculate.getAttribute('quantity-calculate'));
               try {
                   const response = await fetch('/wp-admin/admin-ajax.php', {
                       method: 'POST',
                       body: formData,
                       signal: this.controller.signal
                   });
                   if(response.ok) {
                       this.calculate.innerHTML = await response.text();
                   } else {
                       console.log(("Error HTTP: " + response.status));
                   }
               } catch(err) {
                   if (err.name == 'AbortError') { // cancel fetch by controller.abort()
                       console.log("Abort!");
                   } else {
                       console.log(err);
                   }
               }
               
           } else {
               this.resetCalculate();
           }
       }
   }

   const objs = document.querySelectorAll('[quantity]');
   if(objs.length != 0) objs.forEach(obj => new Quantity(obj).init());

   class Validation {
       constructor(form, emailName = 'billing_email', required = ':required') {
           this.form = form;
           this.code = '+39';
           this.phoneNumber = '';
           this.phoneInputName = 'billing_phone';
           this.emailInputName = emailName;
           this.paymentInputName = 'payment_method';
           this.paymentVisualBlockLogic = '[payment-method]';
           this.inputRequiredLogic = `input:not([type="hidden"]):not([type="checkbox"])${required}`;
           this.textareaRequiredLogic = `textarea${required}`;
           this.checkboxRequiredLogic = `input[type="checkbox"]${required}`;
           this.textError = '[text-error]';
   		this.maxInputLength = 255;
           this.invalid = { };
       }
       init() {
           this.inputValidation();
           this.textareaValidation();
           this.checkboxValidation();
           this.phoneValidation();
           this.emailValidation();
           this.paymentValidation();
       }

       get isValid() {
           const requiredInputs = this.form.querySelectorAll(this.inputRequiredLogic);
           const requiredCheckboxs = this.form.querySelectorAll(this.checkboxRequiredLogic);
           const requiredTextarea = this.form.querySelectorAll(this.textareaRequiredLogic);
           const requiredPaymentBlocks = this.form.querySelectorAll(this.paymentVisualBlockLogic);

           if(requiredInputs ) requiredInputs.forEach(elem =>  {
   			this.requiredInput(elem);
               this.isError(elem);
   		});
           if(requiredCheckboxs) requiredCheckboxs.forEach(elem => {
               this.requiredCheckbox(elem);
           });

           if(requiredTextarea) requiredTextarea.forEach(elem => {
               this.requiredTextarea(elem);
               this.isError(elem);
           });
           
           if(requiredPaymentBlocks.length != 0) {
               let dataFromStorage = JSON.parse(localStorage.getItem('checkout'));
               
               if(dataFromStorage && dataFromStorage['payment_method']) {
                   this.requiredPayment(true);
               } else {
                   this.requiredPayment(false);
               }
           }

           // console.dir(this.invalid)
           return Object.keys(this.invalid).length == 0
       }

       phoneValidation() {
           const phonesInput = this.form.querySelectorAll(`input[name=${this.phoneInputName}]`);
           if(phonesInput) {
               phonesInput.forEach(phone => {
                   phone.addEventListener('focusin', (e) => {
                       this.addPhonePrefix(phone);
                   });
                   phone.addEventListener('beforeinput', (e) => {
                       this.phoneNumber = phone.value;
                   });
                   phone.addEventListener('input', (e) => {
                       this.blockingPhonePrefix(phone);
                       this.validatePhone(phone);
                   });
                   phone.addEventListener('focusout', (e) => {
                       this.validatePhone(phone);
                   });
               });
           }
       }
       emailValidation() {
           const emailsInput = this.form.querySelectorAll(`input[name=${this.emailInputName}]`);
           if(emailsInput) {
               emailsInput.forEach(email => email.addEventListener('input', (e) =>{
                   this.validateEmail(email);
               }));
           }
       }
       paymentValidation() {
           let requiredPaymentBlocks = this.form.querySelectorAll(this.paymentVisualBlockLogic);
           if(requiredPaymentBlocks) requiredPaymentBlocks.forEach(elemClicked => {
               elemClicked.addEventListener('click', (e) => {
                   requiredPaymentBlocks.forEach(elem => {
                       elem.classList.remove('err');
                       if(elemClicked == elem) {
                           elem.classList.add('active');
                       } else {
                           elem.classList.remove('active');
                       }
                   });
               });
           });
       }
   	inputValidation() {
   		const inputs = this.form.querySelectorAll('input[type="text"]');
   		const inputsState = this.form.querySelectorAll('input[type="state"]');
   		if(inputs) inputs.forEach(input => input.addEventListener('input', (e) => {
   			this.limitMaxLength(input);
   		}));
   		if(inputsState) inputsState.forEach(input => input.addEventListener('input', (e) => {
   			this.limitMaxLength(input);
   		}));
           const requiredInputs = this.form.querySelectorAll(this.inputRequiredLogic);
           if(requiredInputs) {
               requiredInputs.forEach(input => {
                   // if(input.getAttribute(name) != this.phoneInputName && input.getAttribute(name) != this.emailInputName) {
                       input.addEventListener('input', (e) => {
                           this.requiredInput(input);
                       });
                       input.addEventListener('change', (e) => {
                           this.isError(input);
                       });
                   // }
                   
               });
           }
           
   	}
       textareaValidation() {
           const textareas = this.form.querySelectorAll(this.textareaRequiredLogic);
           if(textareas) textareas.forEach(textarea => textarea.addEventListener('input', (e) => {
   			textarea.addEventListener('input', (e) => {
                   this.limitMaxLength(textarea);
                   this.requiredTextarea(textarea);
               });
               textarea.addEventListener('change', (e) => {
                   this.isError(textarea);
               });
   		}));
       }
       checkboxValidation() {
   		const checkboxs = this.form.querySelectorAll(this.checkboxRequiredLogic);
           if(checkboxs) checkboxs.forEach(checkbox => {
               checkbox.addEventListener('change', (e) => {
                   this.requiredCheckbox(checkbox);
               });
           });
       }
   	limitMaxLength(that) {
           const name = that.getAttribute('name');
   		if(that.value.length <= this.maxInputLength) {
               that.classList.remove('err');
               if(name in this.invalid) delete this.invalid[name];
           } else {
               that.classList.add('err');
               Object.assign(this.invalid, {
                   [name]: that.value
               });
           }
   	}
       requiredInput(that) {
           const name = that.getAttribute('name');
   		if(that.value.length == 0) {
               that.classList.add('err');
               Object.assign(this.invalid, {
                   [name]: that.value
               });
           } else if (name == this.emailInputName) {
               this.validateEmail(that);
           } else if(name == this.phoneInputName) {
               this.validatePhone(that);
           }
           // else {
           //     that.classList.remove('err');
           //     if(name in this.invalid) delete this.invalid[name]
           // }
       }
       requiredTextarea(that) {
           const name = that.getAttribute('name');
   		if(that.value.length == 0) {
               that.classList.add('err');
               Object.assign(this.invalid, {
                   [name]: that.value
               });
           } else {
               that.classList.remove('err');
               if(name in this.invalid) delete this.invalid[name];
           }
       }
       requiredCheckbox(that) {
           if(that.checked) {
               that.classList.remove('err');
               delete this.invalid[that.id];
           } else {
               that.classList.add('err');
               Object.assign(this.invalid, {
                   [that.id]: false
               });
           }
       }
       requiredPayment(choosen) {
           if(choosen) {
               delete this.invalid['payment'];
           } else {
               Object.assign(this.invalid, {
                   'payment': false
               });
           }
           let requiredPaymentBlocks = this.form.querySelectorAll(this.paymentVisualBlockLogic);
           if(requiredPaymentBlocks) requiredPaymentBlocks.forEach(elem => {
               if(choosen) {
                   elem.classList.remove('err');
               } else {
                   elem.classList.add('err');
               }
           });
       }
       isError(that) {
           const name = that.getAttribute('name');
           const textError = that.parentNode.querySelector(this.textError);
           if(textError) {
               if(that.classList.contains('err') || (name in this.invalid)) {
                   textError.classList.add('active');
               } else {
                   textError.classList.remove('active');
               }
           }
       }

       addPhonePrefix(that) {
           that.value = !(that.value.length > this.code.length) ? this.code : that.value;
       }
       blockingPhonePrefix(that) {
           that.value.indexOf(this.code) && (that.value = this.phoneNumber);
       }
       validatePhone(that) {
           const pattern = /[0-9]+$/;
           //delete all symbols except + and digitals
           that.value = that.value[0] + that.value.slice(1).replace(/[^\d]/g, '');

           if (that.value.length > 18) {
               that.value = that.value.slice(0, 18);
           }
           
           if(that.value.length < 12 || that.value.length > 18 || !pattern.test(that.value)) {
               that.classList.add('err');
               Object.assign(this.invalid, {
                   [that.getAttribute('name')]: that.value
               });
           } else {
               that.classList.remove('err');
               if(that.getAttribute('name') in this.invalid) delete this.invalid[that.getAttribute('name')];
           }
       }
       validateEmail(that) {
           //pattern from https://emailregex.com/
           var pattern = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
           
           if(pattern.test(that.value)) {
               that.classList.remove('err');
               if(that.getAttribute('name') in this.invalid) delete this.invalid[that.getAttribute('name')];
           } else {
               that.classList.add('err');
               Object.assign(this.invalid, {
                   [that.getAttribute('name')]: that.value
               });
           }
       }
   }

   // const forms = document.querySelectorAll('[form-validation]')
   // if(forms) forms.forEach(form => new Validation(form).init())

   class Storage {
       constructor(form) {
           this.form = form;
           this.paymentVisualBlock = 'payment-method';
           this.paymentVisualIcon = 'payment-method-icon';
           this.paymentVisualText = 'payment-method-text';
           this.paymentVisualInputs = 'input[name="payment_method"]';
           this.inputLogic = 'input:not([type="hidden"]):not([type="checkbox"])';

           this.storageKey = this.form.getAttribute('form-save-data') || 'idealis-data';
           this.dataFromStorage = JSON.parse(localStorage.getItem(this.storageKey));
       }
       init() {
           if(this.dataFromStorage) {
               this.setDataFromStorage();
           } else {
               this.setDefaultDataForPayment();
           }
           this.handleStorage();
       }
       setDataFromStorage() {
           const inputs = this.form.querySelectorAll(this.inputLogic);
           if(inputs) inputs.forEach(input => {
               const value = this.dataFromStorage[input.getAttribute('name')];
               if(input.getAttribute('type') == 'radio' && input.getAttribute('name') == 'payment_method') {
                   if(input.value == value) {
                       setTimeout(function() {
                           input.checked = true;
                       }, 0);
                       this.setValueForPaymentBlock(value);
                       this.setValueForPaymentIcon(value);
                       this.setValueForPaymentText(value);
   				}
               } else {
                   if(value) input.value = value;
               }
           });
           if(!this.dataFromStorage['payment_method']) {
               this.setDefaultDataForPayment();
           }
       }
       
       setValueForPaymentBlock(value = 'cod') {
   		const paymentBlock = this.form.querySelector(`[${this.paymentVisualBlock} = ${value}]`);
   		if(paymentBlock)  paymentBlock.classList.add('active');
       }
       setValueForPaymentIcon(value = 'cod') {
   		const paymentIcon = this.form.querySelector(`[${this.paymentVisualIcon} = ${value}]`);
   		if(paymentIcon)  paymentIcon.classList.add('active');
       }
       setValueForPaymentText(value = 'cod') {
   		const paymentText = this.form.querySelector(`[${this.paymentVisualText} = ${value}]`);
   		if(paymentText)  paymentText.classList.add('active');
       }
       setValueForPaymentInput() {
           const input = this.form.querySelector(this.paymentVisualInputs);
   		input.checked = true;
       }

       handleStorage() {
           const inputs = this.form.querySelectorAll(this.inputLogic);
           if(inputs) inputs.forEach(input => input.addEventListener('change', (e) => {
   			this.saveDataToStorage(input);
   		}));
       }
       saveDataToStorage(that) {
           const name = that.getAttribute('name');
           const dataItem = {
               [name]: that.value
           };
           this.dataFromStorage = (this.dataFromStorage) ?  Object.assign(this.dataFromStorage, dataItem) : dataItem;
           localStorage.setItem(this.storageKey, JSON.stringify(this.dataFromStorage));
       }
       setDefaultDataForPayment() {
           // do not need to set default value
           // setTimeout(function() {
           //     const inputs = this.form.querySelectorAll(this.inputLogic);
           //     inputs[0].checked = true;
           // }, 0)
           // this.setValueForPaymentBlock();
           // this.setValueForPaymentIcon();
           // this.setValueForPaymentText();
           // this.setValueForPaymentInput();
       }
   }

   // const forms = document.querySelectorAll('[form-save-data]')
   // if(forms) forms.forEach(form => new Storage(form).init())

   class Modal {
       constructor(obj = document) {
           this.obj = obj;
           this.modal;
       }
       init() {
           const modalOpenBtn = this.obj.querySelectorAll('[data-modal-open]');
           if(modalOpenBtn) {
               modalOpenBtn.forEach(btnItem => btnItem.addEventListener(`click`, (e) => {
                   e.preventDefault();
                   this.openPopupModal(btnItem);
               }));
           }
       }
       openPopupModal(that) {
           let dataPopup = that.dataset.modalOpen;
           const prop = {
               redirectLink: that.dataset.link
           };
           this.modal = this.obj.querySelector(`[data-modal="${dataPopup}"]`);
           if(this.modal) this.openPopup(prop);
       }
       
       openPopup(prop) {
           let link = this.modal.querySelector('a[modal-redirect]');
           if(link) link.href= prop.redirectLink;
           this.modal.classList.add("active");
           document.body.style.overflow = 'hidden';
           this.closePopup();
           this.closePopupByKey();
       }
       closePopup() {
           let modalCloseBtn = this.modal.querySelectorAll("[data-modal-close]");
           modalCloseBtn.forEach(btn => btn.addEventListener("click", (e) => {
               this.modal.classList.remove("active");
               document.body.style.overflow = 'auto';
           }));
       }

       closePopupByKey() {
           window.addEventListener("keydown", (e) => {
               if (e.keyCode === 27) {
                   if (this.modal.classList.contains("active")) {
                       e.preventDefault();
                       this.modal.classList.remove("active");
                       document.body.style.overflow = 'auto';
                   }
               }
           });
       }

   }

   jQuery(document).ready(function () {
       if(jQuery("[steps-form]").length != 0) {
           var form = jQuery("[steps-form]").show();
           const totalAddressInput = form.find('[user-address-data] input').length;
           let paymentMethodBlocks,
               paymentMethodInputs,
               paymentMethodIcons,
               paymentMethodTexts,
               btnSubmit,
               storageData,
               validation,
               formPart;
           form.steps({
               title: "Step Title",
               headerTag: "h3",
               bodyTag: "fieldset",
               transitionEffect: "slideLeft",
               cssClass: "steps-form",
               titleTemplate: '<span class="number">#index#</span> <span class="name">#title#</span><span class="change">Modificare</span>',
               labels: {
                   current: "",
                   finish: "Ordinare",
                   next: "Avanti",
               },
               onInit: function (event, currentIndex) {
                   
                   storageData = new Storage(form[0]);
                   storageData.init();

                   formPart = form.find('.form__fieldset.current');
                   validation = new Validation(formPart[0]);
                   validation.init();

                   new Modal(form[0]).init();
                   handlePaymentMethod();
               },
               onStepChanging: function (event, currentIndex, newIndex)
               {
                   // Allways allow previous action even if the current form is not valid!
                   if (currentIndex > newIndex)
                   {
                       return true;
                   }
                   
                   return validation.isValid;
               },
               onStepChanged: function (event, currentIndex, priorIndex)
               {
                   // Used to skip the "Warning" step if the user is old enough and wants to the previous step.
                   if (currentIndex === 2 && priorIndex === 3)
                   {
                       form.steps("previous");
                   }

                   let formPart = form.find('.form__fieldset.current');
                   validation = new Validation(formPart[0]);
                   validation.init();

                   this.style.setProperty("--percent-number-1", currentIndex * 50 + "%");
                   this.style.setProperty("--percent-number-2", currentIndex * 50 + 30 + "%");

                   if(currentIndex == 2) {
                       setCustomerData();
                       setValueToAddress2Input();
                   }
               },
               onFinishing: function (event, currentIndex)
               {
                   return true;
               },
               onFinished: function (event, currentIndex)
               {
                   
               }
           });

           function setCustomerData() {
               form.find('[user-name-result]').text(form.find('input[name="billing_first_name"]').val());
               let address = '';

               form.find('[user-address-data] input').each((i, elem) => {
                   address += elem.value;
                   if(i !== totalAddressInput - 1 && elem.value.length != 0) address += ', ';
               });
               form.find('[user-address-result]').text(address);
           }

           function setValueToAddress2Input() {
               let inputAddress2 = form.find('[name="billing_address_2"]');
               if(inputAddress2) {
                   let value = '';
                   form.find('[name^="billing_address_2_"]').each((i,elem) => {
                       value += elem.value + ', ';
                   });
                   inputAddress2[0].setAttribute('value', value);
               }
           }

           function handlePaymentMethod() {
               paymentMethodBlocks = form.find('[payment-method]');
               paymentMethodInputs = form.find('input[name="payment_method"]');
               paymentMethodIcons = form.find('[payment-method-icon]');
               paymentMethodTexts = form.find('[payment-method-text]');
               btnSubmit = form.find('[type="submit"]');
               paymentMethodBlocks.each((i, block) => {
                   block.addEventListener('click', togglePaymentMethodBlock);
               });
               paymentMethodInputs.each((i, input) => {
                   input.addEventListener('change', togglePaymentMethodInput);
               });
           }
           function togglePaymentMethodBlock(e) {
               const value = this.getAttribute('payment-method');
               paymentMethodInputs.each((i, input) => {
                   if(input.value == value) {
                       input.checked = true;
                       // it needs for changing shipping price
                       let event = new Event('change', {bubbles: true});
                       input.dispatchEvent(event);
                       // end changing shipping price
                       storageData.saveDataToStorage(input);
                   }
               });
               paymentMethodIcons.each((i, icon) => {
                   if(icon.getAttribute('payment-method-icon') == value ) {
                       icon.classList.add('active');
                   } else {
                       icon.classList.remove('active');
                   }
               });
               paymentMethodTexts.each((i, text) => {
                   if(text.getAttribute('payment-method-text') == value ) {
                       text.classList.add('active');
                   } else {
                       text.classList.remove('active');
                   }
               });
               if(!btnSubmit[0].hasAttribute('data-payment')) {
                   btnSubmit[0].setAttribute('data-payment', value);
               } else {
                   btnSubmit[0].dataset.payment = value;
               }

           }
           function togglePaymentMethodInput(e) {
               paymentMethodBlocks.each((i, block) => {
                   if(block.getAttribute('payment-method') == this.value) {
                       block.classList.add('active');
                   } else {
                       block.classList.remove('active');
                   }
               });
               paymentMethodIcons.each((i, icon) => {
                   if(icon.getAttribute('payment-method-icon') == this.value ) {
                       icon.classList.add('active');
                   } else {
                       icon.classList.remove('active');
                   }
               });
               paymentMethodTexts.each((i, text) => {
                   if(text.getAttribute('payment-method-text') == this.value ) {
                       text.classList.add('active');
                   } else {
                       text.classList.remove('active');
                   }
               });
               if(!btnSubmit[0].hasAttribute('data-payment')) {
                   btnSubmit[0].setAttribute('data-payment', this.value);
               } else {
                   btnSubmit[0].dataset.payment = this.value;
               }
           }
       }
   });

   const form = document.querySelector('[form-feedback] form');
   let validation;
   if(form) {
       const submitBtn = form.querySelector('[type="submit"]');
       validation = new Validation(form, 'your-email', '[aria-required="true"]');
       validation.init();
       submitBtn.addEventListener('click', beforeSubmit);
       form.addEventListener( 'wpcf7invalid ', function( response ) {
           console.log('Fires when an Ajax form submission has completed successfully, but mail hasn’t been sent because there are fields with invalid input.');
       }, false );
   }
   function beforeSubmit(e) {
       if(!validation.isValid) e.preventDefault();
       return validation.isValid;
   }

   window.onload = function() {
       const elems =  document.querySelectorAll("[fixed]");
       if (elems) elems.forEach(elem => fixedElem(elem));
   };


   function fixedElem(elem) {
       elem.style.position = 'fixed';
       elem.classList.add('fixed');
       elem.style.cssText +=  `${elem.getAttribute('fixed')}: 0;`;
       let documentWidth = document.body.clientHeight;
       let elemBottomPosition = elem.getBoundingClientRect().bottom;
       window.addEventListener('resize', function(event){
           documentWidth = document.body.clientHeight;
           elemBottomPosition = elem.getBoundingClientRect().bottom;
       });
       document.addEventListener('scroll', function handleScroll() {
           if(elemBottomPosition + window.pageYOffset >= documentWidth - 20) {
               elem.style.position = 'relative';
               elem.classList.remove('fixed');
           } else {
               if(!elem.classList.contains('fixed')) {
                   elem.style.position = 'fixed';
                   elem.classList.add('fixed');
               }
           }
       });
   }

   (function () {

       const mobileEventHandler = {
           NATIVE_LOG_COMMAND: "logEvent",
           NATIVE_CLOSE_COMMAND: "closeWebview",
           PURCHASE_EVENT: "webview_purchase",
           ADD_TO_CART_EVENT: "webview_add_to_cart",
       
           closeWebview: function () {
               this.sendToNative(this.NATIVE_CLOSE_COMMAND, null);
           },
       
           sendAddToCartEvent: function (itemName) {
               this.sendEvent(this.ADD_TO_CART_EVENT, {
                   itemName: itemName
               });
           },
       
           sendPurchaseEvent: function (revenue) {
               this.sendEvent(this.PURCHASE_EVENT, {
                   revenue: revenue
               });
           },
       
           sendEvent: function (eventName, parameters) {
               this.sendToNative(this.NATIVE_LOG_COMMAND, {
                   eventName: eventName,
                   parameters: parameters
               });
           },
       
           sendToNative: function (command, args) {
               if (window.HealthTrackerWebInterface) {
                   const message = {
                       command: command,
                       args: args,
                   };
       
                   window.HealthTrackerWebInterface.postMessage(JSON.stringify(message));
               } else {
                   console.log("No native APIs found.");
               }
           }    
       };

       // SET EVENTS:
       try {

           // Закрывает WebView на девайсе 
           if(document.querySelector('footer button[close-window]')){
               document.querySelector('footer button[close-window]').addEventListener('click', function(){
                   mobileEventHandler.closeWebview();
               });
           }
           if (document.querySelector('header a[data-event="return-button"]')) {
               document.querySelector('header a[data-event="return-button"]').addEventListener('click', function () {
                   mobileEventHandler.closeWebview();
                 });
             }
           if(document.querySelector('div[data-modal="thankyou"] .message__btn a.btn.btn--light.message__btn-item')){
               document.querySelectorAll('div[data-modal="thankyou"] .message__btn a.btn.btn--light.message__btn-item').forEach(function(button){
                   button.addEventListener('click', function(){
                       mobileEventHandler.closeWebview();
                   });
               });
           }

           // Отправляет эвент о добавлении товара в корзину
           document.querySelectorAll('.add-good-to-basket-js-event').forEach(function (button) {
               button.addEventListener('click', function () {
                   var productName = this.dataset.productName;
                   mobileEventHandler.sendAddToCartEvent(productName);
               });
           });

           // Отправляет эвент о покупке
           document.querySelector('form[steps-form]').addEventListener('submit', makePurchase);
           function makePurchase(e) {
               var totalAmount = document.querySelector('form[steps-form] .woocommerce-Price-amount.amount bdi').textContent.substr(1);
               mobileEventHandler.sendPurchaseEvent(totalAmount);
           }

       } catch (error) {
           console.error(error);
       }

       // END
   })();

})));
